import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4l-5 8l5 8","key":"svg-0"}],["path",{"d":"M16 4l5 8l-5 8","key":"svg-1"}]]

const IconBracketsAngle = createReactComponent('outline', 'brackets-angle', 'BracketsAngle', __iconNode);

export default IconBracketsAngle;